(function () {
  if (typeof window.initProductCardSliders === "function") {
    window.initProductCardSliders();
    return;
  }
  let scheduled = false;
  const pending = new Set();
  const startSlider = (slider) => {
    if (!slider.isConnected || slider.classList.contains("slider_started")) return;
    slider.querySelectorAll("template[data-product-card-slide]").forEach((template) => {
      template.replaceWith(template.content.cloneNode(true));
    });
    new Swiper(slider, {
      slidesPerView: 1,
      speed: 250,
      spaceBetween: 0,
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next-1"),
        prevEl: slider.querySelector(".swiper-button-prev-1"),
      },
      pagination: {
        el: slider.querySelector(".product-card-pagination"),
        clickable: true,
      },
    });
    slider.classList.add("slider_started");
    pending.delete(slider);
    observer?.unobserve(slider);
  };
  const observer = "IntersectionObserver" in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) startSlider(entry.target);
        });
      }, { rootMargin: "300px 0px" })
    : null;
  const initSliders = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      pending.forEach((slider) => {
        if (!slider.isConnected) {
          observer?.unobserve(slider);
          pending.delete(slider);
        }
      });
      document.querySelectorAll(".swiper-container").forEach((slider) => {
        if (slider.classList.contains("slider_started") || pending.has(slider)) return;
        if (!observer || window.Shopify?.designMode || !slider.closest(".product-card")) {
          startSlider(slider);
        } else {
          pending.add(slider);
          observer.observe(slider);
        }
      });
    });
  };
  window.initProductCardSliders = initSliders;
  initSliders();
  document.addEventListener("shopify:section:load", initSliders);
  const startInteractedCard = (event) => {
    const card = event.target.closest?.(".product-card");
    card?.querySelectorAll(".swiper-container").forEach(startSlider);
  };
  document.addEventListener("pointerdown", startInteractedCard, { capture: true, passive: true });
  document.addEventListener("focusin", startInteractedCard, true);
})();
